<div class="m-4" *transloco="let t">
  <form [formGroup]="ruleForm" class="flex flex-col gap-2">
    <IRadioGroup formControlName="hasRule" name="inventoryRule" class="flex flex-col gap-2">
      <label iLabel for="neverPause" class="flex cursor-pointer gap-2" type="card">
        {{ t("asin-inventory-rules-modal.never_pause_checkbox", { asin: modalData.asin }) }}
        <IRadio id="neverPause" [value]="false" size="lg" />
      </label>
      <label iLabel for="pause" class="flex cursor-pointer gap-2" type="card">
        {{ t("asin-inventory-rules-modal.pause_radio_title") }}
        <IRadio id="pause" [value]="true" size="lg" />
        <div content class="flex flex-col gap-4 p-2">
          <div class="flex flex-col gap-1">
            <IFormField>
              <label iLabel>{{ t("asin-inventory-rules-modal.pause_message", { asin: modalData.asin }) }}</label>
              <input
                iInput
                [formControl]="pauseThreshold"
                type="number"
                id="pauseThreshold"
                [placeholder]="t('asin-inventory-rules-modal.threshold_placeholder')"
              />
            </IFormField>
            <div class="block text-xs text-red-500">
              @if (pauseThreshold.invalid && (pauseThreshold.dirty || !pauseThreshold.untouched)) {
                @if (pauseThreshold.errors?.["min"]) {
                  {{ t("asin-inventory-rules-modal.threshold_minimum") }}
                } @else if (pauseThreshold.errors?.["required"]) {
                  {{ t("asin-inventory-rules-modal.threshold_mandatory") }}
                }
              }
            </div>
          </div>
          <ICheckbox
            label="{{ t('asin-inventory-rules-modal.advertise_expected_checkbox') }}"
            [disabled]="ruleForm.controls.activateAdvertisingWhenInbound.disabled"
            [value]="ruleForm.controls.activateAdvertisingWhenInbound.value"
            (valueChange)="ruleForm.controls.activateAdvertisingWhenInbound.setValue($event)"
          />
          <ICheckbox
            label="{{ t('asin-inventory-rules-modal.only_fba_checkbox') }}"
            [disabled]="ruleForm.controls.onlyFba.disabled"
            [value]="ruleForm.controls.onlyFba.value"
            (valueChange)="ruleForm.controls.onlyFba.setValue($event)"
          />
        </div>
      </label>
    </IRadioGroup>
    @if (modalData.warningMessage) {
      <IAlert class="my-4" type="warning">{{ modalData.warningMessage }}</IAlert>
    }
    <button
      iButton
      class="self-end"
      type="button"
      [iTooltip]="t('asin-inventory-rules-modal.apply_this_on_button', { asin: modalData.asin })"
      size="md"
      [disabled]="ruleForm.invalid"
      (click)="save()"
    >
      {{ t("common.save") }}
    </button>
  </form>
</div>
